<div class="container-nuestra-facultad" #columnTexto>
     <div class="descripcion-facultad" [style.background-color]="info?.venue?.color" >
          <div class="title-container-facultad">
              <div class="icono-facultad">
                  <img *ngIf="svgContent" [src]="svgContent" />
              </div>
              <div class="title-facultad">
                  <h1 class="quicksand-bold"> {{ info?.venue?.title }}</h1>
                  <h2 class="quicksand-medium">Sede <strong> {{ info?.venue?.sede }} </strong> </h2>
             </div>
          </div>
           <div class="column-texto" >
             <h2 class="quicksand-bold">NUESTRA FACULTAD</h2>
  
             <div class="html-container" [class.expanded]="isExpanded">
               <div class="html" [innerHTML]="info?.venue?.description | sanitizeHtml"></div>
             </div>
              <hr class="mob divider"  style="height: 1px;width: 100%;margin: 2px 0px 0px 0px!important;background:white!important;">

             <button type="button" class="btn-toggle-ver" (click)="toggleExpand()">
               <span class="quicksand-bold">{{ isExpanded ? 'ver -' : 'ver +' }}</span>
             </button>
           </div>
     </div>
     </div>